import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import Dialog from './../../UiComponents/Dialog';
import getLabel from './../../../utils/labels'
import errorIcon from './../../../globals/images/alert.svg';
import styles from './confirmation.module.scss';

class Confirmation extends Component {
    render() {
        const classname = classNames(styles.dialog, {
            "logoutDepth": this.props.isTutorialLogout
        });

        return (
            <Dialog
                overlayClassName={classname}
                isFooterNeeded={false}
            >
                <div
                    className={styles.container}
                    style={
                        this.props.isTutorialLogout ? { zIndex: '100000 !important' } : {}
                    }
                >
                    <div className={styles.message}>
                        <img
                            src={errorIcon}
                            style={{
                                marginBottom: '20px'
                            }}
                        />
                        <div>{this.props.confimationMessage}</div>
                    </div>
                    <div className={styles.buttons}>
                        <div className={styles.closeButton} onClick={() => this.props.onCancelClick()}>{getLabel('label_cancel_button')}</div>
                        {
                            !this.props.isErrorBox ?
                                <div className={styles.submitButton} onClick={() => this.props.onAcceptClick()}>{this.props.acceptButtonText}</div>
                                :
                                null

                        }
                    </div>
                </div>
            </Dialog>
        )
    }
}


Confirmation.defaultProps = {
    isTutorialLogout: false
};

export default Confirmation


// WEBPACK FOOTER //
// /src/components/commonComponents/confirmationBox/Confirmation.js